'use client';

import LucideIcon from '@/components/ui/LucideIcon';
import { Box, Button, Flex, Text } from '@skin-seoul/design-system';
interface PaginationSectionProps {
  currentPage: number;
  totalPages: number;
  onPageChange: (page: number) => void;
}
const PaginationSection = ({
  currentPage,
  totalPages,
  onPageChange
}: PaginationSectionProps) => {
  const pages: number[] = [];
  const startPage = Math.max(1, currentPage - 2);
  const endPage = Math.min(totalPages, currentPage + 2);
  for (let i = startPage; i <= endPage; i++) {
    pages.push(i);
  }
  const handlePrevious = () => {
    if (currentPage > 1) {
      onPageChange(currentPage - 1);
    }
  };
  const handleNext = () => {
    if (currentPage < totalPages) {
      onPageChange(currentPage + 1);
    }
  };
  const renderPageNumbers = () => <>
      {startPage > 1 && <>
          <Button variant="ghost" size="sm" onClick={() => onPageChange(1)}>
            1
          </Button>
          {startPage > 2 && <Text>...</Text>}
        </>}

      {pages.map(page => <Button key={page} variant={page === currentPage ? 'plain' : 'ghost'} size="sm" backgroundColor={page === currentPage ? 'neutral.50' : 'transparent'} borderRadius="50%" onClick={() => onPageChange(page)}>
          {page}
        </Button>)}

      {endPage < totalPages && <>
          {endPage < totalPages - 1 && <Text>...</Text>}
          <Button variant="ghost" size="sm" onClick={() => onPageChange(totalPages)}>
            {totalPages}
          </Button>
        </>}
    </>;
  const previousButton = <Button variant="outline" size="sm" borderColor="neutral.100" disabled={currentPage === 1} onClick={handlePrevious}>
      <LucideIcon name="ArrowLeftIcon" color="neutral.600" />
      <Text display={{
      base: 'none',
      tablet: 'inline'
    }}>Previous</Text>
    </Button>;
  const nextButton = <Button variant="outline" size="sm" borderColor="neutral.100" disabled={currentPage === totalPages} onClick={handleNext}>
      <Text display={{
      base: 'none',
      tablet: 'inline'
    }}>Next</Text>
      <LucideIcon name="ArrowRightIcon" color="neutral.600" />
    </Button>;
  return <Box paddingY={6} borderTop="1px solid" borderColor="neutral.50" data-sentry-element="Box" data-sentry-component="PaginationSection" data-sentry-source-file="PaginationSection.tsx">
      <Flex align="center" justify="space-between" gap={2} width="100%" data-sentry-element="Flex" data-sentry-source-file="PaginationSection.tsx">
        {previousButton}

        <Flex align="center" gap={2} data-sentry-element="Flex" data-sentry-source-file="PaginationSection.tsx">
          {renderPageNumbers()}
        </Flex>

        {nextButton}
      </Flex>
    </Box>;
};
export default PaginationSection;